import { useId } from 'react';
import { UserRound } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageProvider';
import { FITNESS_INSTRUCTORS, type FitnessInstructorId } from '@/lib/fitnessInstructor';
import { getFitnessPreferencesCopy } from '@/lib/fitnessPreferencesCopy';

interface Props {
  value: FitnessInstructorId;
  onChange: (value: FitnessInstructorId) => void;
  disabled?: boolean;
  busy?: boolean;
  error?: boolean;
  onRetry?: () => void;
}
export default function FitnessInstructorSelector({ value, onChange, disabled = false, busy = false, error = false, onRetry }: Props) {
  const { lang } = useLanguage(), copy = getFitnessPreferencesCopy(lang), groupId = useId();
  return <section className="min-w-0 rounded-2xl border border-border bg-card px-4"><h3 className="flex min-h-12 items-center gap-2 py-3 text-sm font-semibold text-primary"><UserRound size={18} aria-hidden="true" />{copy.instructor}: {copy[value]}</h3><fieldset aria-busy={busy} className="min-w-0 pb-4">
    <legend className="sr-only">{copy.instructor}</legend>
    <p className="mb-3 text-xs leading-relaxed text-muted-foreground">{copy.instructorHint}</p>
    <div className="grid grid-cols-2 gap-3">
      {FITNESS_INSTRUCTORS.map(instructor => <label key={instructor.id}
        className={'flex min-h-14 cursor-pointer items-center gap-2 rounded-xl border p-3 text-sm font-medium focus-within:ring-2 focus-within:ring-primary ' + (value === instructor.id ? 'border-primary bg-primary/10 text-primary' : 'border-border')}>
        <input type="radio" disabled={disabled || busy} name={groupId} value={instructor.id} checked={value === instructor.id} onChange={() => onChange(instructor.id)} className="accent-primary" />
        <UserRound size={18} aria-hidden="true" /><span>{copy[instructor.id]}</span>
      </label>)}
    </div>
    {busy && <p role="status" className="mt-2 text-sm text-muted-foreground">{copy.saving}</p>}
    {error && <p role="alert" className="mt-2 text-sm text-destructive">{copy.saveError}</p>}
    {error && onRetry && <button type="button" onClick={onRetry} className="min-h-11 text-sm text-primary">{copy.retry}</button>}
  </fieldset></section>;
}
